import { RefurbishedProductIndexInterface } from "../../../common/interfaces/apiV2/refurbished/RefurbishedProductIndexInterface";

export const mapRefurbishedProductSpecifications = (
    product: RefurbishedProductIndexInterface,
    artNrLabel: string,
): { label: string; value: string }[] => {
    const specifications: { label: string; value: string }[] = [];

    if (product.product_identifier) {
        specifications.push({
            label: artNrLabel,
            value: product.product_identifier,
        });
    }

    product.product_attributes?.forEach((attribute) => {
        specifications.push({
            label: attribute.label,
            value: attribute.value ?? "No value",
        });
    });

    return specifications;
};
